//
//
//
//
//
//
//
//
//
//
//
//

var onCollectImg = 'https://obj.pipi.cn/festatic/common/media/1662433050890-colected.png';
var unCollectImg = 'https://obj.pipi.cn/festatic/common/image/c9a3b2483049a02884db08581d13d1d4.png';
// 项目收藏按钮
export default {
  name: 'ProjectCollectButton',
  props: {
    isCollect: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _window, _window$Drip, _window$Drip$UA;
    return {
      onCollectImg: onCollectImg,
      unCollectImg: unCollectImg,
      isShowKefuBtn: (_window = window) === null || _window === void 0 ? void 0 : (_window$Drip = _window.Drip) === null || _window$Drip === void 0 ? void 0 : (_window$Drip$UA = _window$Drip.UA) === null || _window$Drip$UA === void 0 ? void 0 : _window$Drip$UA.IS_DouyinShowMicroApp
    };
  },
  mounted: function mounted() {
    this.statView();
  },
  methods: {
    handleCollect: function handleCollect() {
      this.$emit('onCollect');
    },
    statView: function statView() {
      window.seedAction({
        evt: 'view',
        bid: 'b_movie_b_ye0v08k2_mv'
      });
    },
    handleGoKeFu: function handleGoKeFu() {
      var link = document.createElement('a');
      link.href = 'tel:4000553566';
      link.click();
    }
  }
};